{
  "common": {
    "back_to_sign_in": "Back to sign in",
    "sign_out": "Sign out",
    "resend_code": "Resend code",
    "resend_in": "Resend in {{seconds}}s",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "copy_secret": "Copy secret",
    "secret_copied": "Copied to clipboard"
  },
  "shell": {
    "tagline": "Managing energy. Building towards progress.",
    "eyebrow": "NRG CMX",
    "legal": "© NRG Group {{year}}"
  },
  "sign_in": {
    "heading": "welcome back",
    "subhead": "Sign in to NRG CMX",
    "submit": "Sign in",
    "forgot": "Forgot password?",
    "email": "Email",
    "password": "Password"
  },
  "forgot": {
    "heading": "reset your password",
    "subhead": "we'll email you a 6-digit code",
    "submit": "Send reset code",
    "email": "Email"
  },
  "confirm_reset": {
    "heading": "enter your code",
    "subhead": "we sent a code to {{destination}}",
    "subhead_no_destination": "we sent you a code by email",
    "submit": "Update password",
    "code": "Verification code",
    "new_password": "New password",
    "confirm_password": "Confirm password"
  },
  "confirm_sign_in": {
    "heading": "enter your code",
    "subhead_totp": "open your authenticator app and enter the 6-digit code",
    "subhead_sms": "we sent a code to your phone",
    "subhead_email": "we sent a code to your email",
    "submit": "Verify"
  },
  "force_new_password": {
    "heading": "set a new password",
    "subhead": "this is your first sign-in. Choose a password to continue.",
    "submit": "Continue",
    "new_password": "New password",
    "confirm_password": "Confirm password"
  },
  "setup_totp": {
    "heading": "set up two-factor",
    "subhead": "open your authenticator app and add a new account using the secret below, then enter the 6-digit code.",
    "secret_label": "Setup secret",
    "secret_hint": "Tap to copy. Use this in apps like 1Password, Authy, or Google Authenticator.",
    "submit": "Verify and continue"
  },
  "rules": {
    "min_length": "At least {{count}} characters",
    "uppercase": "An uppercase letter",
    "lowercase": "A lowercase letter",
    "number": "A number",
    "symbol": "A symbol"
  },
  "errors": {
    "email_invalid": "Enter a valid email",
    "password_required": "Password is required",
    "passwords_mismatch": "Passwords don't match",
    "code_six_digits": "Enter the 6-digit code",
    "password_policy_failed": "Password doesn't meet the requirements",
    "cognito_invalid_credentials": "Email or password is incorrect",
    "cognito_user_not_confirmed": "Confirm your account before signing in",
    "cognito_code_mismatch": "That code is incorrect",
    "cognito_code_expired": "That code has expired - request a new one",
    "cognito_limit_exceeded": "Too many attempts - try again in a few minutes",
    "cognito_password_policy": "Password doesn't meet the requirements",
    "cognito_password_reset_required": "Your password has been reset - set a new one to continue",
    "cognito_invalid_parameter": "One of the values you entered is invalid",
    "generic": "Something went wrong. Try again."
  }
}
